// extracted by mini-css-extract-plugin
export default {"root":"MenuItem_root__f7RR0","disabled":"MenuItem_disabled__o2XIa"};